import _classCallCheck from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { paragraphGet } from '../../../redux/actions/Entity/Paragraph';
import EntityMapperContext from '../../../Context/EntityMapperContext';

var Paragraph = /*#__PURE__*/function (_Component) {
  _inherits(Paragraph, _Component);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, _getPrototypeOf(Paragraph).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          entity = _this$props.entity,
          viewMode = _this$props.viewMode,
          id = _this$props.id,
          dispatch = _this$props.dispatch,
          currentLanguage = _this$props.currentLanguage;

      if (id && (!entity || entity.getIn(['langcode', 0, 'value']) !== currentLanguage)) {
        dispatch(paragraphGet(id, viewMode));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          viewMode = _this$props2.viewMode,
          id = _this$props2.id,
          dispatch = _this$props2.dispatch,
          currentLanguage = _this$props2.currentLanguage;

      if (id && (id !== prevProps.id || currentLanguage !== prevProps.currentLanguage)) {
        dispatch(paragraphGet(id, viewMode));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var entity = this.props.entity;

      if (!entity) {
        return null;
      }

      var paragraphType = entity.getIn(['type', 0, 'target_id']);
      return /*#__PURE__*/React.createElement(EntityMapperContext.Consumer, null, function (entityTypesMapper) {
        var paragraphMappers = entityTypesMapper.paragraph;
        var ParagraphComponent = paragraphMappers[paragraphType];

        if (ParagraphComponent) {
          return /*#__PURE__*/React.createElement(ParagraphComponent, _this.props);
        }

        return /*#__PURE__*/React.createElement("div", null, entity.getIn(['type', 0, 'target_id']));
      });
    }
  }]);

  return Paragraph;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    entity: ownProps.entity || state.getIn(['paragraph', ownProps.id]),
    currentLanguage: state.getIn(['ui', 'language'])
  };
}

export default connect(mapStateToProps)(Paragraph);